import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage';
import { MyDayPage } from '@/pages/MyDayPage';
import { TasksPage } from '@/pages/TasksPage';
import { TaskDetailPage } from '@/pages/TaskDetailPage';
import { DocumentsPage } from '@/pages/DocumentsPage';
import { DocumentDetailPage } from '@/pages/DocumentDetailPage';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { ProjectDetailPage } from '@/pages/ProjectDetailPage';
import { NotesPage } from '@/pages/NotesPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { PreferencesPage } from '@/pages/PreferencesPage';
import { EmailPage } from '@/pages/EmailPage';
import { CalendarPage } from '@/pages/CalendarPage';
import { ContactsPage } from '@/pages/ContactsPage';
import { ChatPage } from '@/pages/ChatPage';
import { SearchPage } from '@/pages/SearchPage';
import { PresentationsPage } from '@/pages/PresentationsPage';
import { FinancePage } from '@/pages/FinancePage';
import { WorkflowsPage } from '@/pages/WorkflowsPage';
import { TimeTrackingPage } from '@/pages/TimeTrackingPage';
import { OAuthCallbackPage } from '@/pages/OAuthCallbackPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate to="/my-day" replace />} />
        <Route path="/my-day" element={<MyDayPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/documents/:documentId" element={<DocumentDetailPage />} />
        <Route path="/email" element={<EmailPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/presentations" element={<PresentationsPage />} />
        <Route path="/finance" element={<FinancePage />} />
        <Route path="/workflows" element={<WorkflowsPage />} />
        <Route path="/time-tracking" element={<TimeTrackingPage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
      </Route>

      <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
